/**
 * Drafts kept across unmounts so leaving a surface does not throw typed work
 * away: the ChatComposer's unsent message (by `${workspaceId}:${draftKey}`)
 * and the Quick Capture text note (one, per workspace).
 *
 * Memory only, never browser storage: the text can be PHI. And per USER:
 * WorkspaceContext calls `clearInMemoryDrafts` whenever the signed-in identity
 * changes (sign-out, the idle auto-logout, an account switch), none of which
 * reloads the page, so a draft never reaches the next person on the tab.
 * (2026-10 unsaved-work audit; the sign-out leak was review finding F1 on
 * #3703.)
 */

export const chatDrafts = new Map<string, { input: string; attachedFiles: File[] }>();

export interface QuickCaptureTextDraft {
  readonly workspaceId: string;
  readonly content: string;
  readonly name: string;
}

let quickCaptureTextDraft: QuickCaptureTextDraft | null = null;

export function getQuickCaptureTextDraft(): QuickCaptureTextDraft | null {
  return quickCaptureTextDraft;
}

export function setQuickCaptureTextDraft(draft: QuickCaptureTextDraft | null): void {
  quickCaptureTextDraft = draft;
}

export function clearInMemoryDrafts(): void {
  chatDrafts.clear();
  quickCaptureTextDraft = null;
}
